/**
 * Intake attribution for every "Get Started" CTA on a treatment PDP (ET-216).
 *
 * Both entries share `source` deliberately — a shopper who starts intake from
 * this page is `src=pdp` wherever on it they clicked — and differ only in
 * `ctaLocation`, so reporting can tell the buy column's button from the
 * below-the-fold one. Co-located so that contract is visible in one file: the
 * two used to sit in separate modules under separate naming schemes, which is
 * how a `source` value drifts without anyone noticing.
 *
 * Lives under `~/hec/telehealth/` rather than beside the PDP route because a
 * registered Builder block consumes it, and blocks must not reach into
 * `~/routes/**` for runtime values.
 */

/** The buy column's price + CTA pair. */
export const PDP_CTA_CONTEXT = {
  source: "pdp",
  ctaLocation: "pdp-main",
} as const;

/** The below-the-fold "How it Works" section's CTA. */
export const PDP_HOW_IT_WORKS_CTA_CONTEXT = {
  source: PDP_CTA_CONTEXT.source,
  ctaLocation: "pdp-how-it-works",
} as const;
